<script>
export default {

    props: {
      ended: {
        type: [Boolean],
        default: false
      }
    },

    created() {
        if(this.ended) {
            swal({ 
                html:true, 
                title:'', 
                text: "Für dieses Event können keine Bestellungen mehr getätigt werden.",
                type: "warning"
            });
        }
    },
}
</script>
